var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 33,
    fill: "url(#pattern0_112_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_112_4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_112_4",
    transform: "matrix(0.0111111 0 0 0.0104377 0 0.030303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_112_4",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADN0lEQVR4nO2c225SQRSG5x2sMdpWMfFlTLQaX8DGC0+19Vl6V4t64aWXnh+kpGifoUbACwXaz0wYIiGIMHtO7LW+hBsCw15/FmvPnvlnGaMoiqIoiqIoiqKUCXAV2AW+AG3gp3u13XvPgM3c17myAOvAC2DI/zkD3gKN3Ne9UgB3gR7L0wW2cl//SgA8dxnqi/3uXu44ViGTzyqIPCm2ZvYsgA3PcjGvjFyZ+WOSAV4TnmbuuEqcwg0jCG3H3MgdXzEAe8RjJ3d8xQB8jij0x9zxFQNwElHodu74ioGws41pernjKwagE1HoTu74igE4iij0ce74igC4BnyNKLTsmyGjufM+8Iu4PDESARpu+fM38RmIe2AhXQZPcmCEZfBhogyexM5kLpu6g5/AfeA80DLpbVNn8Be46b677WprFZF3jQCB+x4CX58a6w5w6lkubpk6QkCBp8ZdW2JzduA+W7+aTCSBZ/zOReAR8N49QXbc2sixfRgBnhYxhfuHL8Ju87SAD8BjG0xpAq/aHtyrBf96Q/fXW5szngoc0Bdxam9EKnAaX8QAuK8ZnMYXca41eH5NjrlTIesml9gXMU/gN8ANI4mIvohp5GVwQl+E3AxO7Iv4JjaDE/sijnLHVwyRZxvd3PFJEfpH7viKIfJ2fSt3fFJuhid6COev0PYIWEz6Or0bCb2Z+IGlYaQCvEwg9Bi5Ge4OQNqdk5T0RWa4PfKVeZm0YYSte1Rd+N+uuPDfkJTZXc+trK2psXwFPxQhuD3M6LJrUV/EAXBhzngq+AI7LzvAJ+eF6DlvhPVIvAMeJrIbyMjw0JBIcOCSNZM7s0zLlUR5/TqIJLhzKC1a+obuOWLd1B0CCg7cA76zPHL6dTASvOkrOPCg4nKCrH4d+AseyoguI7MrCh4Cmf06yHNYSG6/DtJmuPbrIF2Ga7+OiQyPaZeQfUR5Erc0EAvt1zEm8oaF9utI5EvRfh2JfCnar2OMNq+qhy9FZr+OxL4Uef06MvlS5PTryOhLkdGvwwfgZqASUv9+HQX4Uurdr6MQX0p9+3XEwm3O7i/YjebMmS61Jgf2pZTXr0NRFEVRFEVRFMVE4g/R2nVw+7ZeWwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.f13383d7745f3f1e48b9ce1ce5afcbec.svg";
export { ForwardRef as ReactComponent };